angular.module('wbDashboard').controller('FundingActivityHistoricalControllerAurea',
    ['$scope', '$state', '$filter', '$timeout', 'User', 'NgTableParams',
function ($scope, $state, $filter, $timeout, User, NgTableParams) {

    $scope.pageData = {
        tabs: {
            active: 'funding',
            scrollTop: true,
            data: {
                "funding": {label: 'Funding', value: 'funding'},
                "trades": {label: 'Trades', value: 'trades', callbacks: {afterEnter: updateSelect}},
            }
        }
    };

    $scope.existingTransactions = {
        "pending" : null,
        "complete" : null
    };
    $scope.tradeTransactions = null;

    $scope.options = {
        activityTypes: [
            'Deposit', 'Withdrawal', 'Transfer', 'Dividend', 'Formula', 'Other'
        ],
        tradeTypes: [
            'Buy', 'Sell'
        ],
        accounts: [],
        msAccounts: [],
        selectedMSAccount: null,
        selectedAccount: null,
        selectedMilestone: null,
        selectedTypes: null
    };

    $scope.msTransactionTable = {
        pending: {},
        complete: {}
    };
    $scope.tradeTable = {};


    User.retrieveTradeHistory();
    $scope.$watch(function() { return User.getTradeHistory(); }, function(trades) {
        if (trades) {
            $scope.tradeTransactions = trades;
        }
    });

    User.retrieveFundingActivity(null); //this is now static so only need to retrieve it once
    $scope.$watch(function() { return User.getFundingActivity(); }, function(transactions) {
        if (transactions) {
            $scope.existingTransactions.pending = transactions.pending;
            $scope.existingTransactions.complete = transactions.complete;

            $scope.existingTransactions.pendingGrouped = {};
            angular.forEach($scope.existingTransactions.pending, function(t) {
                if (!$scope.existingTransactions.pendingGrouped[t.date]) {
                    $scope.existingTransactions.pendingGrouped[t.date] = [];
                }
                t.ms =  User.getMilestones(t.milestone_id);
                $scope.existingTransactions.pendingGrouped[t.date].push(t);
            });

            $scope.existingTransactions.completeGrouped = {};
            angular.forEach($scope.existingTransactions.complete, function(t) {
                if (!$scope.existingTransactions.completeGrouped[t.date]) {
                    $scope.existingTransactions.completeGrouped[t.date] = [];
                }
                t.ms =  User.getMilestones(t.milestone_id);
                $scope.existingTransactions.completeGrouped[t.date].push(t);
            });


        }
    });

    $scope.$watch(User.getOverview, function(overview) {
        if (overview) {
            $scope.options.accounts.length = 0;

            angular.forEach(overview.account_overview, function(account) {
                $scope.options.accounts.push({
                    account_number: account.account_number,
                    type: account.type,
                    name: account.name
                });
            });

        }
    });

    $scope.$watchCollection(function() { return User.getMSandWallet(); }, function(milestones) {
        if (milestones) {
            $scope.options.msAccounts.length = 0;
            angular.forEach(milestones, function(milestone) {
                angular.forEach(milestone.accounts, function(account) {
                    $scope.options.msAccounts.push({
                        milestone_id: milestone.id,
                        account_number: account.account_number,
                        name: milestone.name + " - " + account.name
                    });
                });
            });

        }
    });

    $scope.updateSelect = updateSelect;
    function updateSelect() {
        //to resize properly when tab is selected
        $timeout(function() {
            angular.element('.select-trade-type').trigger('change.select2');
        }, 50);
    }


    /**
     *
     *  Milestone Transaction Tables
     *
     */

    $scope.$watchCollection('existingTransactions.pending', function (transactions) {
        setExistingTransactionTable('pending', transactions);
    });
    $scope.$watchCollection('existingTransactions.complete', function (transactions) {
        setExistingTransactionTable('complete', transactions);
    });
    function setExistingTransactionTable(type, transactions) {
        if (!$scope.msTransactionTable[type].tableParams) {
            //only needs to be set once
            $scope.msTransactionTable[type].tableParams = getTransactionsTableParams([{
                type_extra: "Please Wait",
                milestone_name: "Loading"
            }]);
        }

        if (transactions) {
            //update dataset config rather than creating new NgTableParams
            $scope.msTransactionTable[type].tableParams.settings({
                dataset : User.formatFundingTableData(transactions)
            });
        }
    }
    function getTransactionsTableParams(dataSet) {
        var tableData = {};
        tableData.tableParams = new NgTableParams({
            count: 10,
            sorting: { date: "desc"}
        }, {
            counts: [],
            // determines the pager buttons (left set of buttons in demo)
            paginationMaxBlocks: 7,
            paginationMinBlocks: 0,
            dataset:dataSet,
            filterOptions: { filterFilterName: "fundingTransactionFilter" }
        });

        return tableData.tableParams;

    }


    /**
     *
     *  Account Activity Transactions Tables
     *
     */

    $scope.$watchCollection('tradeTransactions', function(trades) {
        if (!$scope.tradeTable.tableParams) {
            //only needs to be set once
            $scope.tradeTable.tableParams = getTradeTableParams([{
                description: "Please Wait",
                account_description: "Loading"
            }]);
        }
        if (trades) {
            $scope.tradeTable.tableParams.settings({
                dataset: formatTradeTableData(trades)
            });
        }

    });

    function formatTradeTableData(trades) {
        var dataSet = [];

        angular.forEach(trades, function(trade) {
            var data = angular.copy(trade);

            var tradeDate = new Date(trade.date.replace(" ","T"));

            data.amount = parseFloat(trade.price) * parseFloat(trade.shares);
            data.type = trade.transaction_type;
            data.shares_real = null;

            //convert time to remove unwanted UTC to current timeaone conversion
            data.date = new Date( tradeDate.getTime() + ( tradeDate.getTimezoneOffset() * 60000 ) );

            if (trade.transaction_type.indexOf("Buy") === 0 || trade.transaction_type.indexOf("Sell") === 0) {
                data.shares_real = parseFloat(trade.shares);
            }
            switch (trade.transaction_type) {
                case "Dividend":
                    data.description = "Dividends from " + trade.ticker;
                    break;
                case "Deposit":
                case "Withdrawal":
                    data.description = trade.transaction_type;
                    break;
                case "Transfer In":
                case "Transfer Out":
                    data.type = "Transfer";
                    /* falls through */
                default:
                    data.description = trade.transaction_type + " " + (trade.ticker ? trade.ticker : "");
                    break;
            }

            dataSet.push(data);
        });

        return dataSet;
    }
    function getTradeTableParams(dataSet) {
        var tableData = {};
        tableData.tableParams = new NgTableParams({
            count: 10,
            sorting: { date: "desc"}
        }, {
            counts: [],
            // determines the pager buttons (left set of buttons in demo)
            paginationMaxBlocks: 7,
            paginationMinBlocks: 0,
            dataset:dataSet,
            filterOptions: { filterFilterName: "fundingTradeFilter" }
        });

        return tableData.tableParams;
    }

    /**
     * Custom Options
     */

    //customization of select2 tag display
    $scope.s2templateSelection = function(data, $container) {
        $timeout(function() {
            //need to remove the tag after it's appended to body
            // $container.parent().text("Items Selected");
            // $container.remove();
            var $parent = $container.parent();
            if ($parent.length) {
                var selected = $parent.find('li.select2-selection__choice').length;
                $parent.find('.select2-search input').attr('placeholder', selected + " selected");
            }

        }, 50);
        return data.text;
    };


    $scope.$watch('options.selectedTypes', function(types) {
        changeMSFilter('type', types);
    });
    $scope.$watch('options.selectedMSAccount', function(types) {
        changeMSFilter('msAccount', types);
    });
    $scope.$watch('options.wildcardAll', function(types) {
        changeMSFilter('$', types);
    });

    function changeMSFilter(field, value){
        var filter = {};
        filter[field] = value;
        angular.extend($scope.msTransactionTable.pending.tableParams.filter(), filter);
        angular.extend($scope.msTransactionTable.complete.tableParams.filter(), filter);
    }


}]).filter("fundingTransactionFilter", ['$filter', function($filter) {
    return function(data, typeCriteria){
        var filtered = (data || []);

        filtered = filtered.filter(function(item){
            var match = true;

            angular.forEach(typeCriteria, function(value, key) {
                var test;
                switch (key) {
                    case 'type':
                        if (value.length) {
                            test = value.includes(item.type);

                            if (value.includes('Formula') && !test) {
                                test = !!item.formula_slug;
                            }

                            if (value.includes("Other") && !test) {
                                //if other, then check to see if type is not any of the options, if it isn't, then true
                                test =    !["Deposit", "Withdrawal", "Transfer", "Dividend"].includes(item.type)
                                       && !item.formula_slug;
                            }

                            match &= test;

                        }
                        break;
                    case 'milestone':
                        match &= value === item.milestone_id;
                        break;
                    case 'msAccount':
                        //item needs to be in value
                        if (value.length) {
                            test = value.filter(function(value) {
                                return value.account_number == item.account_number && value.milestone_id == item.milestone_id;
                            });
                            match &= !!test.length;
                        }
                        break;
                }
            });

            return match;
        });
        if ('$' in typeCriteria) {
            filtered = $filter('filter')(filtered, { $:typeCriteria.$ } );
        }

        return filtered;
    };
}]).filter("fundingTradeFilter", ['$filter', function($filter) {
    return function(data, typeCriteria){
        var filtered = (data || []);

        filtered = filtered.filter(function(item){
            var match = true;
            angular.forEach(typeCriteria, function(value, key) {
                var test;
                switch (key) {
                    case 'account':
                        if (value.length) {
                            test = value.filter(function(value) {
                                return value.account_number == item.account_number;
                            });
                            match &= !!test.length;
                        }
                        break;
                    case 'type':
                        match &= value.length === 0 || value.indexOf(item.type) !== -1;
                        break;
                }
            });

            return match;
        });
        if ('$' in typeCriteria) {
            filtered = $filter('filter')(filtered, { $:typeCriteria.$ } );
        }

        return filtered;
    };
}]);
